export const SET_MESSAGE = "SET_MESSAGE";

export const CLEAR_MESSAGES = "CLEAR_MESSAGES";
